import { Icon, List, ListItem, Navbar, Page } from "framework7-react";

import { NavLeftBack } from "@/components/NavLeftBack";
import { NavRightEmpty } from "@/components/NavRightEmpty";
import { NavTitle } from "@/components/NavTitle";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { usePageReady } from "@/hooks/usePageReady";

export const AppAboutPage = createPage("AppAboutPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const { getPageProps } = usePageReady(pageName);
  return (
    <Page
      data-component={pageName}
      {...getPageProps()}
    >
      <Navbar>
        <NavLeftBack />
        <NavTitle>アプリについて</NavTitle>
        <NavRightEmpty />
      </Navbar>

      <List
        dividersIos
        inset
        mediaList
        strong
      >
        <ListItem
          chevronCenter
          link="#"
          title="プライバシーポリシー"
        >
          <Icon
            material="person"
            slot="media"
          />
        </ListItem>

        <ListItem
          chevronCenter
          link="#"
          title="利用規約"
        >
          <Icon
            material="settings"
            slot="media"
          />
        </ListItem>

        <ListItem
          after={__APP_VERSION__}
          title="アプリバージョン"
        >
          <Icon
            material="numbers"
            slot="media"
          />
        </ListItem>

        <ListItem
          chevronCenter
          link="#"
          title="お問い合わせ"
        >
          <Icon
            material="headset_mic"
            slot="media"
          />
        </ListItem>
      </List>
    </Page>
  );
}
